import { gsap } from "gsap";

export default class FooterCircle {
  constructor() {
    this.circle = document.querySelector("[data-footer-circle]");
    this.footer = this.circle?.closest("footer");
    if (!this.circle || !this.footer) return;

    this.isInView = false;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.initObserver();
  }

  onScroll() {
    if (!this.isInView || this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      const footerRect = this.footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const footerHeight = footerRect.height;
      const visibleHeight =
        Math.min(windowHeight, footerHeight + footerRect.top) -
        Math.max(0, footerRect.top);
      const progress = Math.min(Math.max(visibleHeight / footerHeight, 0), 1);

      // Instead of changing width/height, apply scale transform
      const scale = 0.9 + progress * 0.1;
      gsap.set(this.circle, { scale, transformOrigin: "center center" });

      this.ticking = false;
    });
  }

  initObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isInView = true;
            window.addEventListener("scroll", this.onScroll, { passive: true });
            this.onScroll(); // run immediately
          } else {
            this.isInView = false;
            window.removeEventListener("scroll", this.onScroll);
          }
        });
      },
      { threshold: 0 },
    );

    observer.observe(this.footer);
  }
}
